var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "agreement-container" }, [
      _c("div", { staticClass: "title" }, [
        _c("h4", [_vm._v(_vm._s(_vm.pubAgreement.name))]),
        _vm._v(" "),
        _c("span", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.pubAgreement.createTime))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          domProps: { innerHTML: _vm._s(_vm.pubAgreement.content) }
        },
        [_c("span")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b3564f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3564f2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/PubAgreement.vue
// module id = 1753
// module chunks = 1